<div [ngBusy]="{busy: isBusy, message: ''}">

    <div *ngIf="(mode === 'ADD' || (mode === 'UPDATE' && status === 'SUCCESS')); else skeleton">
        <form [formGroup]="contactFrm">
            <div class="d-flex flex-wrap justify-content-start row" *ngIf="(!updateEntityCheck && isAddContactAllowed && contactTypeList.length > 0) || action === 'UPDATE'">
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label">Contact Type <app-required-label></app-required-label></label>
                    <ng-container *ngIf="action === 'ADD'">
                        <app-select [options]="contactTypeList" formControlName="contactType" [ngClass]="{'is-invalid': isControlInvalid(f.contactType)}" [isInvalid]="isControlInvalid(f.contactType)">
                        </app-select>
                    </ng-container>
                    <ng-container *ngIf="action === 'UPDATE'">
                        <app-select [options]="origContactTypeList" formControlName="contactType" [ngClass]="{'is-invalid': isControlInvalid(f.contactType)}" [isInvalid]="isControlInvalid(f.contactType)">
                        </app-select>
                    </ng-container>
                    <app-error [isSubmit]="isAdd" [control]="f.contactType" [caption]="'Contact Type'" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label">Last Name <app-required-label></app-required-label></label>
                    <input type="text" formControlName="lastName" class="form-control form-control-sm text-uppercase" [ngClass]="{'is-invalid': isControlInvalid(f.lastName)}" placeholder="Last Name" maxlength="30" title="Should be 2 to 30 characters">
                    <app-error [isSubmit]="isAdd" [control]="f.lastName" [caption]="'Last Name'" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label">First Name<app-required-label></app-required-label></label>
                    <input type="text" formControlName="firstName" class="form-control form-control-sm text-uppercase" [ngClass]="{'is-invalid': isControlInvalid(f.firstName)}" placeholder="First Name" maxlength="30" title="Should be 2 to 30 characters">
                    <app-error [isSubmit]="isAdd" [control]="f.firstName" [caption]="'First Name'" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label">Middle Name</label>
                    <input type="text" formControlName="middleName" class="form-control form-control-sm text-uppercase" [ngClass]="{'is-invalid': isControlInvalid(f.middleName)}" placeholder="Middle Name" maxlength="30" title="Should be 1 to 30 characters">
                    <app-error [isSubmit]="isAdd" [control]="f.middleName" [caption]="'Middle Name'" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-2 col-md-auto">
                    <label class="col-form-label">Phone <app-required-label></app-required-label></label>
                    <p-inputMask type="text" styleClass="form-control form-control-sm" formControlName="phone" [ngClass]="{'is-invalid': isControlInvalid(f.phone)}" mask="?(999)999-9999" title="Work phone">
                    </p-inputMask>
                    <app-error [isSubmit]="isAdd" [control]="f.phone" [caption]="'Phone'" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-1 col-md-auto">
                    <label class="col-form-label">Extn </label>
                    <p-inputMask type="text" styleClass="form-control form-control-sm" formControlName="phoneExtn" [ngClass]="{'is-invalid': isControlInvalid(f.phoneExtn)}" mask="?99999" title="Max 5 digits">
                    </p-inputMask>
                    <app-error [isSubmit]="isAdd" [control]="f.phoneExtn" [caption]="'Phone Extn'" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label class="col-form-label">Email <app-required-label></app-required-label></label>
                    <input type="text" class="form-control form-control-sm" formControlName="email" [ngClass]="{'is-invalid': isControlInvalid(f.email)}" placeholder="Email" maxlength="50" title="Work Email">
                    <app-error [isSubmit]="isAdd" [control]="f.email" [caption]="'Email'" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-2 col-md-auto">
                    <label class="col-form-label">Fax </label>
                    <p-inputMask type="text" styleClass="form-control form-control-sm" formControlName="fax" [ngClass]="{'is-invalid': isControlInvalid(f.fax)}" mask="?(999)999-9999" title="Work Fax">
                    </p-inputMask>
                    <app-error [isSubmit]="isAdd" [control]="f.fax" [caption]="'Fax'" class="invalid-feedback">
                    </app-error>
                </div>
            </div>
            <div class="mt-2 border-top border-bottom" *ngIf="(isAddContactAllowed && contactTypeList.length > 0) || action === 'UPDATE'">
                <div class="d-flex justify-content-end mt-1 mb-1">
                    <button pRipple type="submit" class="btn btn-sm btn-primary" (click)="addContact()" *ngIf="action === 'ADD' && isAddContactAllowed">Add</button>
                    <button pRipple type="buton" class="btn btn-sm btn-secondary" (click)="resetContact()" *ngIf="action === 'ADD' && isAddContactAllowed">Reset</button>
                    <button pRipple type="submit" class="btn btn-sm btn-primary" (click)="updateContact()" *ngIf="action === 'UPDATE'">Update</button>
                    <button pRipple type="buton" class="btn btn-sm btn-secondary" (click)="resetContact()" *ngIf="action === 'UPDATE'">Cancel</button>
                </div>
            </div>
        </form>
    </div>
    <div class="mt-2" *ngIf="isSubmit && contactDataList.length === 0">
        <p-message severity="error" text="Please enter contact information"></p-message>
    </div>
    <div class="mt-2" *ngIf="contactDataList.length > 0">
        
        <app-ui-table [headers]="contactHeaders" [data]="contactDataList" [recordsToDisplay]="contactDataList.length" [showExport]="false" [showEdit]="isUpdateContactAllowed" [showDelete]="isUpdateContactAllowed" [disableTable]="action === 'UPDATE'" (rowEditEvent)="editContact($event)"
            (rowDeleteEvent)="deleteContact($event)">
        </app-ui-table>
    </div>
</div>
<ng-template #skeleton>
    <div class="d-flex flex-wrap justify-content-start row">
        <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
            <label for="" class="col-form-label">Contact Type <app-required-label></app-required-label></label>
            <ng-container *ngIf="action === 'ADD'">
                <input type="text" class="empty form-control form-control-sm">
            </ng-container>
            <ng-container *ngIf="action === 'UPDATE'">
                <input type="text" class="empty form-control form-control-sm">
            </ng-container>
        </div>
        <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
            <label for="" class="col-form-label">Last Name <app-required-label></app-required-label></label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
        <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
            <label for="" class="col-form-label">First Name <app-required-label></app-required-label></label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
        <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
            <label for="" class="col-form-label">Middle Name</label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
        <div class="d-flex flex-column col-xl-2 col-md-auto">
            <label class="col-form-label">Phone <app-required-label></app-required-label></label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
        <div class="d-flex flex-column col-xl-1 col-md-auto">
            <label class="col-form-label">Extn </label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
        <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-auto">
            <label class="col-form-label">Email <app-required-label></app-required-label></label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
        <div class="d-flex flex-column col-xl-2 col-md-auto">
            <label class="col-form-label">Fax </label>
            <input type="text" class="empty form-control form-control-sm">
        </div>
    </div>
    <div class="mt-2 border-top border-bottom">
        <div class="d-flex justify-content-end mt-1 mb-1">
            <button pRipple type="submit" class="empty btn btn-sm btn-primary" (click)="addContact()" *ngIf="action === 'ADD'">Add</button>
            <button pRipple type="buton" class="empty btn btn-sm btn-secondary" (click)="resetContact()" *ngIf="action === 'ADD'">Reset</button>
            <button pRipple type="submit" class="empty btn btn-sm btn-primary" (click)="updateContact()" *ngIf="action === 'UPDATE'">Update</button>
            <button pRipple type="buton" class="empty btn btn-sm btn-secondary" (click)="resetContact()" *ngIf="action === 'UPDATE'">Cancel</button>
        </div>
    </div>
    <div class="mt-2">
        <div class="empty m-2"></div>
    </div>
</ng-template>
